const NS = 'SiteSubheaderTopicDropdownWidget';
const CLS = 'siteSubheaderTopicDropdownWidget';

export class SiteSubheaderTopicDropdownWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
        this.$items = this.$element.find(`.${CLS}-program-heading`);

        this.$selectedItem = null;
        this.$itemContentAnimationDuration = 350;
        this.$temHeadingIconAnimationDuration = 250;
        this.$itemHeadingIconRotationDegree = 180;

        this.$items.each((index, element) => {
            let $item = $(element);

            let $program = $item.parent(`.${CLS}-program`);
            if($program.attr('data-active') === 'true') {
                $program.find(`.${CLS}-program-content`).show();
                this.$selectedItem = $program;
            }
        });

        this.$items.on('click', (e) => {
            let activate = (item) => {
                item.find(`.${CLS}-program-content`).slideDown({
                    duration: this.$itemContentAnimationDuration
                });
                rotateIcon(item, 0, this.$itemHeadingIconRotationDegree);
                item.attr('data-active', true);
                this.$selectedItem = item;
            };

            let deactivate = (item) => {
                item.find(`.${CLS}-program-content`).slideUp({
                    duration: this.$itemContentAnimationDuration
                });
                rotateIcon(item, this.$itemHeadingIconRotationDegree, 0);
                item.attr('data-active', false);
                this.$selectedItem = null;
            };

            let rotateIcon = (item, initialDegree, degree) => {
                let $elem = item.find(`.${CLS}-program-heading-icon`);

                $({ deg: initialDegree }).animate({ deg: degree }, {
                    duration: this.$temHeadingIconAnimationDuration,
                    step: (now) => {
                        $elem.css({
                            transform: `rotate(${now}deg)`
                        });
                    }
                });
            };

            let $itemToBeSelected = $(e.currentTarget).parent(`.${CLS}-program`);

            if(!this.$selectedItem) {
                activate($itemToBeSelected);
            }
            else if(this.$selectedItem.attr('id') === $itemToBeSelected.attr('id')) {
                if(this.$selectedItem.attr('data-active')) {
                    deactivate($itemToBeSelected);
                }
            }
            else if(this.$selectedItem.attr('id') !== $itemToBeSelected.attr('id')) {
                deactivate(this.$selectedItem);
                activate($itemToBeSelected);
            }

            // Adjust every time the dropdown is toggled
            let offsetTop = Math.floor(this.$element.offset().top);
            this.$element.css({
                maxHeight: `calc(100vh - ${offsetTop}px)`
            });
        });
	}
}
